import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const MyCheckpoint = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [cities, setcities] = useState([])
    const [isloading, setisloading] = useState(false)

    const handleSearch = (e, data) => {
        setisloading(true)
        let searchTerm = data.searchQuery
        let locations = ReadAxios({ url: 'getRouteCheckPoints', searchTerm: searchTerm }) || [];
        locations.then((res) => {
            setcities(res.data.resultSet)
            setisloading(false)
        })
    }
    let cityNames = []
    if (cities.length > 0) {
        cities.map((object, index) => {
            let temp = {}
            temp.key = object.checkPointCode
            temp.text = object.checkPointName
            temp.value = object.checkPointMasterId
            return cityNames[index] = temp
        })
    }
    return (
        <Dropdown
            selection
            loading={isloading}
            style={{ width: "100%" }}
            search
            onSearchChange={handleSearch}
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={cityNames}
            {...props}
        />

    )
}

export default MyCheckpoint